<template>
    <div aria-live="polite" aria-atomic="true" style="position: relative;">
        <div class="toast notification-toast w-100 d-flex flex-column p-2" role="alert" aria-live="assertive" aria-atomic="true" data-autohide="false">
            <div class="toast-header">
                <i class="fas mr-2" :class="getNotificationIcon(notificationDetails)"></i>
                <strong v-html="notificationDetails.title" class="mr-auto"></strong>&nbsp;
                <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close" @click="closeBubble()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="toast-body text-secondary">
                <span v-html="notificationDetails.text"></span>
                <button class="btn btn-secondary float-right p-1 pl-2 pr-2" @click="openNotificationTarget(notificationDetails)">
                    <i class="fas fa-arrow-right"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapState('login', ['userLoggedIn']),
        ...mapState('negotiation', ['negotiationsList', 'negotiationFuelGroups']),
        ...mapState('notifications', ['showNotificationBubble', 'notificationDetails']),
        ...mapGetters('login', ['getAccountType']),
        ...mapGetters('offers', ['getLiveContracts', 'getHasExistingContracts']),
    },
    methods: {
        ...mapMutations('negotiation', ['SELECT_TAB']),
        ...mapActions('conversation', ['loadConversation']),
        ...mapActions('negotiation', ['getNegotiations', 'selectFuelGroup', 'selectNegotiation', 'setNegotiationSelectedId']),
        ...mapActions('notifications', ['popNotification','updateNotification']),
          ...mapActions('offers', ['getLiveContractsList']),
        closeBubble: function(){
            $('.notification-toast').toast('hide')
            setTimeout(() => {
                this.popNotification(false)
            }, 500)
        },
        openNotificationTarget: function(notificationObject){
            let notificationGroupId = ''

            /* To open a new message */
            if (notificationObject.type == 'message_alert'){
                /* If this is a message for negotiation, then go to negotiation page - otherwise go to OLF Chat */
                if (notificationObject.negotiationId && notificationObject.counterOfferId){
                    if (this.userLoggedIn.category == 'buyer'){
                        this.goToNegotiationsBuyer(notificationObject)
                    }
                    else if (this.userLoggedIn.category == 'seller'){
                        this.goToNegotiationsSeller(notificationObject)
                    }

                    notificationGroupId = notificationObject.negotiationId
                }
                else {
                    this.goToOlfChat(notificationObject.conversationId)
                    notificationGroupId = notificationObject.conversationId
                }
            }
            /* To open a negotiation/counter offer */
            else if (notificationObject.type == 'negotiation_alert' || 
                notificationObject.type == 'negotiation_accept_alert' || 
                notificationObject.type == 'negotiation_revision_alert' || 
                notificationObject.type == 'negotiation_withdrawn_alert' ||
                notificationObject.type == 'counteroffer_alert' || 
                notificationObject.type == 'counteroffer_revision_alert' || 
                notificationObject.type == 'counteroffer_accepted_alert'){
                if (this.userLoggedIn.category == 'buyer'){
                    this.goToNegotiationsBuyer(notificationObject)
                }
                else if (this.userLoggedIn.category == 'seller'){
                    this.goToNegotiationsSeller(notificationObject)
                }

                notificationGroupId = notificationObject.negotiationId
            }
            /* To go to order history */
            else if (notificationObject.type == 'order_placed_alert'){
                this.goToOrderHistory()
                notificationGroupId = notificationObject.orderId;
            } else if(notificationObject.type === 'buyer_activated'){
                this.$router.push('/AllPrices/ex-rack');
            }
            this.updateNotification(notificationGroupId);
            this.closeBubble()
        },
        goToOlfChat: function(conversationId){
            /* Go to the page */
            this.$router.push({name: 'OlfChat'})

            /* Select and load the conversation */
            this.loadConversation(conversationId)
        },
        goToNegotiationsBuyer: function(notificationObject){
            const payload = {
                status: 'All',
                accountId: this.userLoggedIn.id
            }

            /* Fetch updated negotiation list then select relevant negotiation */
            this.getNegotiations(payload).then(async () => {
                /* Go to the page */
                this.$router.push({name: 'NegotiationsBuyer'})

                /* Fetch counter offer and fetch conversation ids and indexes */
                const negotiationMatchIndex = await this.negotiationsList.findIndex(negotiation => negotiation._id == notificationObject.negotiationId)
                const counterIndex = await this.negotiationsList[negotiationMatchIndex].counterOffers.findIndex(counter => counter._id == notificationObject.counterOfferId)
                
                let conversationSelectedId = ''
                if (counterIndex > -1){
                    conversationSelectedId = this.negotiationsList[negotiationMatchIndex].counterOffers[counterIndex].conversation_id
                }

                /* Select negotiation */
                this.selectNegotiation(notificationObject.negotiationId).then(() => {
                    if (counterIndex > -1){
                        /* Select counter and conversation */
                        this.loadConversation(conversationSelectedId)
                        this.SELECT_TAB(counterIndex + 1)
                    }
                })
            })
        },
        goToNegotiationsSeller: function(notificationObject){
            const payload = {
                status: 'All',
                accountId: this.userLoggedIn.id
            }

            let fuelIdSelected = ''

            /* Fetch updated negotiation list then select relevant negotiation */
            this.getNegotiations(payload).then(async () => {
                /* Go to the page */
                this.$router.push({name: 'NegotiationsSeller'})
                
                /* Select fuel group, then negotiation */
                const negotiationMatch = await this.negotiationsList.find(negotiation => negotiation._id == notificationObject.negotiationId)
                fuelIdSelected = negotiationMatch.fuel_id
                const fuelGroup = await this.negotiationFuelGroups.find(fuelGroup => fuelGroup.fuel._id == fuelIdSelected)
                const negotiationIndex = await fuelGroup.negotiationList.findIndex(negotiation => negotiation._id == notificationObject.negotiationId)

                this.selectFuelGroup(fuelIdSelected) // Select fuel group
                this.SELECT_TAB(negotiationIndex + 1) // Select negotiation
                this.setNegotiationSelectedId(notificationObject.negotiationId)
            })
        },
        goToOrderHistory: function(){
            this.$router.push("/OrderHistory");
        },
getNotificationIcon: function(notificationDetails){
            const fa_calendar_check = "fa-calendar-check p-2";	
            const fa_chart_line = "fa-chart-line p-2";	
            const fa_comments = "fa-comments p-2";	
            const fa_handshake = "fa-handshake pt-2 pb-2 pl-1 pr-1";	
            const fa_users = "fa-users pt-2 pb-2 pl-1 pr-1";	
            switch (notificationDetails.type){	 
                case 'message_alert':	            
                    return notificationDetails.negotiationId ? 
                        fa_handshake : fa_comments;
                case 'order_placed_alert':
                    return fa_calendar_check;
                case 'negotiation_alert':
                case 'negotiation_accept_alert':
                case 'negotiation_revision_alert':
                case 'negotiation_withdrawn_alert':
                case 'counteroffer_alert':
                case 'counteroffer_revision_alert':
                case 'counteroffer_accepted_alert':
                    return fa_handshake;
                case 'buyer_activated':
                    return fa_users;
                default:
                    return fa_chart_line;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.toast.notification-toast {
    position: absolute; 
    top: 0; 
    right: 0.5rem;
    z-index: 3;
    border-radius: 0.8rem;
    background-color: map-get($theme-colors, olf-white);

    .toast-header .fas {
        border-radius: 50%;
        background-color: #cceaff;
        color: map-get($theme-colors, secondary);
        font-size: 1.5rem;
    }

    .btn-secondary {
        border-radius: 50%;
        max-width: 30px!important;
    }
}
</style>
